/* eslint-disable import/no-unused-modules */

import EVENTS from "../constants/events";
import generateEventPair from "../helpers/generateEventPair";

export const {
  dispatcher: dispatchListingSaved,
  responder: respondToListingSaved
} = generateEventPair({
  eventName: EVENTS.LISTING_SAVED,
  signatureParams: ["listingId", "listingType"]
});
